import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const faqs = [
    {
      question: 'Is this just another frugal living ebook?',
      answer: "No. Most frugal guides give you 50 disconnected tips. SpendLess is a structured system — 7 chapters that build on each other, from auditing your spending to building self-sustaining systems. It's the difference between a recipe and a complete kitchen."
    },
    {
      question: 'What if I live in an apartment? Does the permaculture stuff apply?',
      answer: 'Absolutely. The permaculture chapter covers balcony gardens, windowsill growing, and high-yield methods for small spaces. The DIY chapter scales to whatever you have — even a studio apartment. Most of the savings come from the spending and food strategy chapters, which work everywhere.'
    },
    {
      question: 'How quickly will I see results?',
      answer: 'The spending audit in Chapter 3 typically reveals $100-400/month in invisible waste within the first week. The food strategies save most people 30-40% on groceries immediately. The bigger systems (energy, permaculture) take a few weeks to set up but compound over years.'
    },
    {
      question: 'Do I need to be handy or have a big yard?',
      answer: 'No on both counts. The DIY projects are designed for beginners with basic tools. The guide focuses on high-impact, low-skill projects first. And the spending/food/lifestyle chapters need zero outdoor space.'
    },
    {
      question: 'What format is the guide?',
      answer: 'You get a beautifully formatted PDF plus web access. Read it on your phone, tablet, or computer. The printable checklists and planners are separate PDFs designed for printing.'
    },
    {
      question: 'Is this about extreme frugality or cutting everything fun?',
      answer: "The opposite. SpendLess is about intention, not deprivation. You're not cutting things that matter — you're eliminating invisible waste so you have more money for what you actually care about. Think of it as designing a better life, not a smaller one."
    }
  ];

  return (
    <section className="py-20 px-6 bg-[#EBE6D8]">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-[#2C1810] mb-12 text-center">
          Questions? Answered.
        </h2>
        
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white rounded-lg px-6 border-none shadow-sm"
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-[#2C1810] hover:text-[#6B7A5C] py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[#5A5046] leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;